import $ from 'jquery';

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

$(function () {
    $('[data-toggle="popover"]').popover()
})

$( '[data-toggle="sizePopover"]' ).each(function(index, item){
    $(item).popover({
        content: $(this).children('.data-content').html(),
        html: true
    });
});

var geo_locate_failed;
function geolocate(item) {
    if (navigator.geolocation) {
        var geoFailure = function(error) {
            if (!geo_locate_failed) { 
                geo_locate_failed = true;
                item.parent().parent().before('<div class="">Unable to get your location, please use the box below.</div>')
            }
        }
        var geoSuccess = function(position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            var target = item.data('target') + '?geo_search=' + lat + ',' + lng;
            window.location.href = target;
        }

        navigator.geolocation.getCurrentPosition(
            geoSuccess,
            geoFailure,
            { maximumAge: 50000, timeout: 20000, enableHighAccuracy: true }
        );
    }
};

// Rent : Billing - allows a user to enter a different address for billing
function customBillingAddress() {
    // Get the checkbox
    var checkBox = document.getElementById("differentAddress");
    // Get the output text
    var billingaddress = document.getElementById("billingAddressForm");

    // If the checkbox is checked, display the output text
    if (checkBox.checked == true){
        billingaddress.style.display = "block";
    } else {
        billingaddress.style.display = "none";
    }
}

// Search form - nearby functionality
$('.search-near-me').click(function (e) {
    e.preventDefault();
    geolocate($(this));
});

// Storage guide - load video on navigation 
$("#sizeGuide .nav-link").on('click',function(e) {
    var selector = $(this).attr('href')+' .video-wrapper';
    if (!$(selector+' iframe').length) {
        $(selector).html('<iframe class="embed-responsive-item" src="https://player.vimeo.com/video/' +$(this).attr("data-vidid")+ '?autoplay=0&loop=0' +$(this).attr("data-vidid")+ '" frameborder="0" allowfullscreen></iframe>').show()
    }
});

// load 5x5 on modal open - facility page.
$('button[data-target="#sizeGuideModal"]').click(function() {
    $('#sizeGuide .nav-link.active').click();
})

// load 5x5 on page load - static size guide page.
if ($('#sizeGuide').hasClass('static')) {
    $('#sizeGuide .nav-link.active').click();
}

// mobile behavior for the size guide tab links
$('.nav-link').on('click', function() {
    $('.nav-column').addClass('hideme');
})
$('.show-nav-btn').off('click').on('click', function() {
    $('.nav-column').toggleClass('hideme');
})

// Get the header
var header = document.getElementById("pageheader");

// Get the offset position of the navbar
if(header) {
    var sticky = header.offsetTop;
}

// When the user scrolls the page, execute myFunction

window.onscroll = function() {
    if(header) {
        scrollMyHead()
    }
};

// button that expands/contracts the menu for the tenant dashboard
$(".btn-tenant-nav-mobile").on('click',function(e) {
    $(".tenant-sidebar").toggle();
})

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function scrollMyHead() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

$('.btn-copy').on('click', function() {
    copyTextToClipboard(window.location.href);
})

$('.btn-copy').on('shown.bs.popover', function () {
    setTimeout(function() {
        $('.popover').popover('hide'); 
    }, 500);
});

// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text);
}

// navigator requires https so for local dev we provide a fallback function.
function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position="fixed";  //avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}

$('.site-alert').each(function() {
    var $alert = $(this);
    var key = $alert.attr('id') + '_' + $alert.attr('data-timestamp');

    if (!localStorage.getItem(key)) $alert.show();

    $alert.find('.close').on('click', function(e) {
        localStorage.setItem(key, true);
    });
});

$('#searchbyFilter .dropdown-menu').on('click', function (e) {
    e.stopPropagation();
});

/* NAV FUNCATIONALITY */
let expand = null;
$('.dropdown .dropdown.menu-item-has-children .dropdown-toggle').off('click').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(window).width() >= 992) {
        window.location.href = $(this).attr('href');
    } else {
        let currentDropdownMenu = $('[aria-labelledby="' + $(this).attr('id') + '"]');
        let isExpanded = $(this).attr('aria-expanded') === 'true';

        if (isExpanded) {
            // Collapse the dropdown if it's already expanded
            $(this).attr('aria-expanded', 'false');
            currentDropdownMenu.removeClass('show');
            expand = false;
        } else {
            // Collapse any open dropdowns
            $('.dropdown-menu .dropdown-menu.show').removeClass('show');
            $('.dropdown-toggle').attr('aria-expanded', 'false');

            // Expand this dropdown
            $(this).attr('aria-expanded', 'true');
            currentDropdownMenu.addClass('show');
            expand = true;
        }
    }
});
/* END NAV FUNCATIONALITY */

//Collapse functions for Yoast FAQ
jQuery(function($) {
    var yoast = {
    accordion: function() {
    var isAnimating = false;
    
    $('.schema-faq-section').find('.schema-faq-question').click(function(event) {
    event.stopPropagation();
    
    if (isAnimating) {
    return;
    }
    
    isAnimating = true;
    
    var answer = $(this).nextAll('.schema-faq-answer').eq(0);
    
    answer.slideToggle(250, function() {
    $(this).toggleClass('expanded');
    $(this).prev('.schema-faq-question').toggleClass('expanded');
    isAnimating = false;
    });
    
    $(".schema-faq-answer").not(answer).slideUp('fast');
    });
    
    $('.schema-faq-section .schema-faq-question').click(function(event) {
    event.stopPropagation();
    
    if (isAnimating) {
    return; 
    }
    
    isAnimating = true;
    
    $('.schema-faq-section .schema-faq-question').not($(this)).removeClass('expanded');
    $(this).toggleClass('expanded');
    
    isAnimating = false;
    });
    }
    };
    
    yoast.accordion();
    });
